export default {
  isLoading: false,
  ids: [],
};
